import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';

export default function Gauge({
  fillPrimary = colors.neutral10,
  className = 'h-[20px] w-[20px]',
}: SvgIconCommonProps) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.99979 3.75C8.75916 3.75938 7.53252 4.01304 6.38993 4.49652C5.24734 4.97999 4.21117 5.6838 3.3406 6.56776C2.47004 7.45171 1.78212 8.49849 1.31614 9.64833C0.850155 10.7982 0.615235 12.0285 0.624792 13.2692V15C0.624792 15.3315 0.756488 15.6495 0.990909 15.8839C1.22533 16.1183 1.54327 16.25 1.87479 16.25H18.1248C18.4563 16.25 18.7743 16.1183 19.0087 15.8839C19.2431 15.6495 19.3748 15.3315 19.3748 15V13.2667C19.3934 10.7615 18.4162 8.35156 16.6581 6.56687C14.9 4.78218 12.5049 3.76894 9.99979 3.75Z"
        stroke={fillPrimary}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 16.25V15.625C7.5 14.962 7.76339 14.3261 8.23223 13.8572C8.70107 13.3884 9.33696 13.125 10 13.125C10.663 13.125 11.2989 13.3884 11.7678 13.8572C12.2366 14.3261 12.5 14.962 12.5 15.625V16.25"
        stroke={fillPrimary}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.875 7.50244L10 13.1274"
        stroke={fillPrimary}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 12C3.60166 12 3.45666 12.044 3.33332 12.1264C3.20999 12.2088 3.11386 12.3259 3.05709 12.463C3.00033 12.6 2.98547 12.7508 3.01441 12.8963C3.04335 13.0418 3.11478 13.1754 3.21967 13.2803C3.32456 13.3852 3.4582 13.4566 3.60368 13.4856C3.74917 13.5145 3.89997 13.4997 4.03701 13.4429C4.17406 13.3861 4.29119 13.29 4.3736 13.1667C4.45601 13.0433 4.5 12.8983 4.5 12.75C4.5 12.5511 4.42098 12.3603 4.28033 12.2197C4.13968 12.079 3.94891 12 3.75 12Z"
        fill={fillPrimary}
      />
      <path
        d="M4.75 9C4.60166 9 4.45666 9.04399 4.33332 9.1264C4.20999 9.20881 4.11386 9.32594 4.05709 9.46299C4.00033 9.60003 3.98547 9.75083 4.01441 9.89632C4.04335 10.0418 4.11478 10.1754 4.21967 10.2803C4.32456 10.3852 4.4582 10.4566 4.60368 10.4856C4.74917 10.5145 4.89997 10.4997 5.03701 10.4429C5.17406 10.3861 5.29119 10.29 5.3736 10.1667C5.45601 10.0433 5.5 9.89834 5.5 9.75C5.5 9.55109 5.42098 9.36032 5.28033 9.21967C5.13968 9.07902 4.94891 9 4.75 9Z"
        fill={fillPrimary}
      />
      <path
        d="M16.375 12.5C16.2267 12.5 16.0817 12.544 15.9583 12.6264C15.835 12.7088 15.7389 12.8259 15.6821 12.963C15.6253 13.1 15.6105 13.2508 15.6394 13.3963C15.6684 13.5418 15.7398 13.6754 15.8447 13.7803C15.9496 13.8852 16.0832 13.9566 16.2287 13.9856C16.3742 14.0145 16.525 13.9997 16.662 13.9429C16.7991 13.8861 16.9162 13.79 16.9986 13.6667C17.081 13.5433 17.125 13.3983 17.125 13.25C17.125 13.0511 17.046 12.8603 16.9053 12.7197C16.7647 12.579 16.5739 12.5 16.375 12.5Z"
        fill={fillPrimary}
      />
      <path
        d="M15.125 9.37744C14.9767 9.37744 14.8317 9.42143 14.7083 9.50384C14.585 9.58625 14.4889 9.70338 14.4321 9.84043C14.3753 9.97747 14.3605 10.1283 14.3894 10.2738C14.4184 10.4192 14.4898 10.5529 14.5947 10.6578C14.6996 10.7627 14.8332 10.8341 14.9787 10.863C15.1242 10.892 15.275 10.8771 15.412 10.8204C15.5491 10.7636 15.6662 10.6675 15.7486 10.5441C15.831 10.4208 15.875 10.2758 15.875 10.1274C15.875 9.92853 15.796 9.73776 15.6553 9.59711C15.5147 9.45646 15.3239 9.37744 15.125 9.37744Z"
        fill={fillPrimary}
      />
      <path
        d="M7.25 6.87744C7.10166 6.87744 6.95666 6.92143 6.83332 7.00384C6.70999 7.08625 6.61386 7.20338 6.55709 7.34043C6.50032 7.47747 6.48547 7.62827 6.51441 7.77376C6.54335 7.91924 6.61478 8.05288 6.71967 8.15777C6.82456 8.26266 6.9582 8.33409 7.10368 8.36303C7.24917 8.39197 7.39997 8.37712 7.53701 8.32035C7.67406 8.26359 7.79119 8.16746 7.8736 8.04412C7.95601 7.92078 8 7.77578 8 7.62744C8 7.42853 7.92098 7.23776 7.78033 7.09711C7.63968 6.95646 7.44891 6.87744 7.25 6.87744Z"
        fill={fillPrimary}
      />
    </svg>
  );
}
